export enum LocaleEnum {
  EN = "en",
  DE = "de",
  TH = "th",
}

export enum LocalePrefixEnum {
  AS_NEEDED = "as-needed",
  ALWAYS = "always",
  NEVER = "never",
}
